import React, { useState, useEffect, useCallback } from 'react';

// ── 🚶 PAP — Porta a Porta (29/08/2026) ─────────────────────────────────────
// Central de comando dos agentes de rua: dashboard de produtividade, validação
// das abordagens (foto + flags anti-fraude), gestão de agentes por cidade e
// trajetos do dia. O app que o agente usa na rua é preserva.online/pap/app.

const token = () => localStorage.getItem('token');
const apiGet = (p) => fetch(`/${p}`, { headers: { Authorization: `Bearer ${token()}` } }).then(r => r.json());
const apiSend = (p, m, b) => fetch(`/${p}`, { method: m, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` }, body: b ? JSON.stringify(b) : undefined }).then(async r => { const d = await r.json().catch(() => ({})); if (!r.ok) throw new Error(d.erro || `Erro ${r.status}`); return d; });

const caixa = { background: '#fff', border: '1px solid #c8d0da', borderRadius: 6, padding: '12px 14px', marginBottom: 12 };
const inp = { padding: '5px 8px', borderRadius: 4, border: '1px solid #b0b8c4', fontSize: 13, background: '#fff', color: '#111' };
const btn = (cor = '#0a1628') => ({ background: cor, color: '#fff', border: 'none', borderRadius: 4, padding: '5px 14px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer' });
const fmtDH = (iso) => iso ? new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';

const FLAGS_ROTULO = {
  sem_foto: ['📷 sem foto', '#b45309'],
  sem_gps: ['📍 sem GPS', '#b45309'],
  rapida_demais: ['⚡ <3min da anterior', '#b91c1c'],
  salto_gps: ['🛸 salto de GPS', '#b91c1c'],
};
const INTERESSE_CHIP = {
  sim: ['🔥 SIM', '#15803d', '#dcfce7'],
  talvez: ['🤔 Talvez', '#b45309', '#fef3c7'],
  nao: ['❌ Não', '#64748b', '#f1f5f9'],
};

export default function Pap() {
  const [aba, setAba] = useState('dashboard');
  const ABAS = [
    ['dashboard', '📊 Dashboard'],
    ['validacao', '✅ Validação'],
    ['agentes', '👥 Agentes'],
    ['trajetos', '🗺️ Trajetos'],
  ];
  return (
    <div style={{ maxWidth: 1180 }}>
      <h2 style={{ fontSize: 18, fontWeight: 800, color: '#0a1628', marginBottom: 2 }}>🚶 PAP — Porta a Porta</h2>
      <p style={{ color: '#6b7280', fontSize: 12, marginBottom: 12 }}>
        Agentes externos batendo no comércio Brasil afora. App do agente: <b>preserva.online/pap/app</b>
      </p>
      <div style={{ display: 'flex', gap: 6, marginBottom: 12, flexWrap: 'wrap' }}>
        {ABAS.map(([k, rotulo]) => (
          <button key={k} onClick={() => setAba(k)}
            style={{ padding: '6px 14px', borderRadius: 6, fontSize: 13, fontWeight: aba === k ? 800 : 500, border: '1px solid', borderColor: aba === k ? '#0a1628' : '#d1d5db', background: aba === k ? '#0a1628' : '#fff', color: aba === k ? '#fff' : '#374151', cursor: 'pointer' }}>
            {rotulo}
          </button>
        ))}
      </div>
      {aba === 'dashboard' && <AbaDashboard />}
      {aba === 'validacao' && <AbaValidacao />}
      {aba === 'agentes' && <AbaAgentes />}
      {aba === 'trajetos' && <AbaTrajetos />}
    </div>
  );
}

function AbaDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => {
    const ok = (x) => { if (x && x.hoje) setD(x); };
    apiGet('pap/admin/dashboard').then(ok).catch(() => {});
    const t = setInterval(() => apiGet('pap/admin/dashboard').then(ok).catch(() => {}), 60000);
    return () => clearInterval(t);
  }, []);
  if (!d) return <div style={caixa}>Carregando…</div>;
  const Card = ({ titulo, valor, cor }) => (
    <div style={{ flex: 1, minWidth: 130, background: '#fff', border: '1px solid #c8d0da', borderRadius: 6, padding: '10px 14px', textAlign: 'center' }}>
      <div style={{ fontSize: 22, fontWeight: 800, color: cor || '#0a1628' }}>{valor}</div>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase' }}>{titulo}</div>
    </div>
  );
  return (
    <div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
        <Card titulo="Em campo agora" valor={d.em_campo_agora} cor={d.em_campo_agora ? '#15803d' : '#6b7280'} />
        <Card titulo="Abordagens hoje" valor={d.hoje.abordagens} />
        <Card titulo="Interesses hoje" valor={d.hoje.interesses} cor="#b45309" />
        <Card titulo="Km hoje" valor={d.hoje.km} />
        <Card titulo="Conversão 7 dias" valor={`${d.semana.conversao_pct}%`} cor="#1d4ed8" />
      </div>
      <div style={caixa}>
        <div style={{ fontSize: 13, fontWeight: 800, color: '#0a1628', marginBottom: 8 }}>🏆 Ranking da semana ({d.semana.abordagens} abordagens, {d.semana.interesses} interesses)</div>
        {d.ranking_semana.length === 0 && <div style={{ fontSize: 12.5, color: '#6b7280' }}>Nenhum agente cadastrado ainda — crie o primeiro na aba Agentes.</div>}
        {d.ranking_semana.map((r, i) => (
          <div key={r.nome} style={{ display: 'flex', gap: 10, alignItems: 'center', padding: '6px 0', borderBottom: '1px solid #eef1f5', fontSize: 12.5 }}>
            <span style={{ fontWeight: 800, width: 24 }}>{['🥇', '🥈', '🥉'][i] || `${i + 1}º`}</span>
            <span style={{ fontWeight: 700, flex: 1 }}>{r.nome} <span style={{ color: '#6b7280', fontWeight: 400 }}>({r.cidade})</span></span>
            <span>🏪 {r.abordagens}</span>
            <span style={{ color: '#b45309', fontWeight: 700 }}>🔥 {r.interesses}</span>
            <span style={{ color: '#6b7280' }}>{r.km} km</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function AbaValidacao() {
  const [lista, setLista] = useState([]);
  const [f, setF] = useState({ interesse: '', so_flags: false });
  const [fotoAberta, setFotoAberta] = useState('');
  const carregar = useCallback(() => {
    apiGet(`pap/admin/abordagens${f.interesse ? `?interesse=${f.interesse}` : ''}`).then(d => setLista(Array.isArray(d) ? d : [])).catch(() => {});
  }, [f.interesse]);
  useEffect(() => { carregar(); }, [carregar]);
  const validar = (id, validada) => apiSend(`pap/admin/abordagens/${id}/validar`, 'PUT', { validada }).then(carregar).catch(e => alert(e.message));
  const visiveis = f.so_flags ? lista.filter(a => (a.flags || []).length) : lista;
  return (
    <div>
      <div style={{ ...caixa, display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
        <select value={f.interesse} onChange={e => setF(x => ({ ...x, interesse: e.target.value }))} style={inp}>
          <option value="">Todos os interesses</option>
          <option value="sim">🔥 Só interesse SIM</option>
          <option value="talvez">🤔 Talvez</option>
          <option value="nao">❌ Não</option>
        </select>
        <label style={{ fontSize: 12.5, display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
          <input type="checkbox" checked={f.so_flags} onChange={e => setF(x => ({ ...x, so_flags: e.target.checked }))} />
          ⚠️ Só com alerta de validação
        </label>
        <span style={{ fontSize: 11.5, color: '#6b7280' }}>{visiveis.length} abordagem(ns)</span>
      </div>
      {visiveis.map(a => (
        <div key={a.id} style={{ ...caixa, display: 'flex', gap: 14, flexWrap: 'wrap' }}>
          {a.foto ? (
            <img src={a.foto + `?t=${token()}`} alt="" onClick={() => setFotoAberta(fotoAberta === a.id ? '' : a.id)}
              style={{ width: fotoAberta === a.id ? '100%' : 110, height: fotoAberta === a.id ? 'auto' : 82, objectFit: 'cover', borderRadius: 6, cursor: 'pointer', border: '1px solid #e2e8f0' }} />
          ) : (
            <div style={{ width: 110, height: 82, borderRadius: 6, background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: '#94a3b8' }}>sem foto</div>
          )}
          <div style={{ flex: 1, minWidth: 240 }}>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
              <b style={{ fontSize: 13.5 }}>{a.loja}</b>
              {(() => { const [r, cor, bg] = INTERESSE_CHIP[a.interesse] || INTERESSE_CHIP.nao; return <span style={{ fontSize: 10.5, fontWeight: 800, color: cor, background: bg, borderRadius: 8, padding: '1px 8px' }}>{r}</span>; })()}
              {a.oportunidade_id && <span style={{ fontSize: 10.5, fontWeight: 700, color: '#1d4ed8', background: '#eff6ff', borderRadius: 8, padding: '1px 8px' }}>📋 no CRM</span>}
              {(a.flags || []).map(fl => { const [r, cor] = FLAGS_ROTULO[fl] || [fl, '#b45309']; return <span key={fl} style={{ fontSize: 10.5, fontWeight: 700, color: cor, background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '1px 8px' }}>{r}</span>; })}
            </div>
            <div style={{ fontSize: 12, color: '#374151', marginTop: 3 }}>
              {fmtDH(a.quando)} · {a.agente}{a.responsavel ? ` · 👤 ${a.responsavel}` : ''}{a.contato ? ` · 📱 ${a.contato}` : ''}{a.marca ? ` · ™️ ${a.marca}` : ''}
            </div>
            {a.resumo && <div style={{ fontSize: 12, color: '#6b7280', marginTop: 3 }}>{a.resumo}</div>}
            {a.lat && <a href={`https://maps.google.com/?q=${a.lat},${a.lng}`} target="_blank" rel="noreferrer" style={{ fontSize: 11.5, color: '#1d4ed8' }}>📍 ver no mapa</a>}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, justifyContent: 'center' }}>
            {a.validada === 'ok' && <span style={{ fontSize: 12, fontWeight: 800, color: '#15803d' }}>✅ validada</span>}
            {a.validada === 'rejeitada' && <span style={{ fontSize: 12, fontWeight: 800, color: '#b91c1c' }}>🚫 rejeitada</span>}
            {!a.validada && (<>
              <button style={btn('#15803d')} onClick={() => validar(a.id, 'ok')}>✅ Validar</button>
              <button style={btn('#b91c1c')} onClick={() => validar(a.id, 'rejeitada')}>🚫 Rejeitar</button>
            </>)}
          </div>
        </div>
      ))}
      {visiveis.length === 0 && <div style={caixa}>Nenhuma abordagem {f.so_flags ? 'com alerta' : 'registrada'} ainda.</div>}
    </div>
  );
}

function AbaAgentes() {
  const [lista, setLista] = useState([]);
  const [form, setForm] = useState({ nome: '', telefone: '', cidade: '', uf: '' });
  const [pinNovo, setPinNovo] = useState(null);
  const carregar = useCallback(() => apiGet('pap/admin/agentes').then(d => setLista(Array.isArray(d) ? d : [])).catch(() => {}), []);
  useEffect(() => { carregar(); }, [carregar]);

  const criar = () => apiSend('pap/admin/agentes', 'POST', form)
    .then(d => { setPinNovo({ nome: form.nome, telefone: form.telefone, pin: d.pin, link: d.link }); setForm({ nome: '', telefone: '', cidade: '', uf: '' }); carregar(); })
    .catch(e => alert(e.message));
  const alternar = (a) => apiSend(`pap/admin/agentes/${a.id}`, 'PUT', { ativo: !a.ativo }).then(carregar).catch(e => alert(e.message));
  const novoPin = (a) => apiSend(`pap/admin/agentes/${a.id}`, 'PUT', { novo_pin: true })
    .then(d => setPinNovo({ nome: a.nome, telefone: a.telefone, pin: d.pin, link: 'https://preserva.online/pap/app' }))
    .catch(e => alert(e.message));

  return (
    <div>
      <div style={caixa}>
        <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 8 }}>➕ Contratar agente</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <input placeholder="Nome" value={form.nome} onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} style={{ ...inp, flex: 2, minWidth: 140 }} />
          <input placeholder="Telefone (DDD)" value={form.telefone} onChange={e => setForm(f => ({ ...f, telefone: e.target.value }))} style={{ ...inp, flex: 1, minWidth: 120 }} />
          <input placeholder="Cidade" value={form.cidade} onChange={e => setForm(f => ({ ...f, cidade: e.target.value }))} style={{ ...inp, flex: 1, minWidth: 110 }} />
          <input placeholder="UF" maxLength={2} value={form.uf} onChange={e => setForm(f => ({ ...f, uf: e.target.value }))} style={{ ...inp, width: 50 }} />
          <button style={btn('#15803d')} onClick={criar}>Criar</button>
        </div>
        {pinNovo && (
          <div style={{ marginTop: 10, padding: 12, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, fontSize: 13 }}>
            🔑 <b>{pinNovo.nome}</b> — PIN: <b style={{ fontSize: 17 }}>{pinNovo.pin}</b> (anote — não aparece de novo!)<br />
            <span style={{ fontSize: 12, color: '#374151' }}>Mande pro agente: acesse <b>{pinNovo.link}</b>, entre com o telefone {pinNovo.telefone} e o PIN acima.</span>
          </div>
        )}
      </div>
      {lista.map(a => (
        <div key={a.id} style={{ ...caixa, display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', opacity: a.ativo ? 1 : 0.55 }}>
          <span style={{ fontSize: 16 }}>{a.em_campo ? '🟢' : '⚪'}</span>
          <div style={{ flex: 1, minWidth: 160 }}>
            <b style={{ fontSize: 13.5 }}>{a.nome}</b>
            <div style={{ fontSize: 11.5, color: '#6b7280' }}>{a.cidade}/{a.uf} · 📱 {a.telefone}{a.em_campo ? ' · EM CAMPO AGORA' : ''}</div>
          </div>
          <span style={{ fontSize: 12 }}>🏪 {a.total_abordagens}</span>
          <span style={{ fontSize: 12, color: '#b45309', fontWeight: 700 }}>🔥 {a.total_interesses}</span>
          <span style={{ fontSize: 12, color: '#6b7280' }}>{a.km_total} km</span>
          <button style={btn('#6b7280')} onClick={() => novoPin(a)}>🔑 Novo PIN</button>
          <button style={btn(a.ativo ? '#b91c1c' : '#15803d')} onClick={() => alternar(a)}>{a.ativo ? 'Desativar' : 'Reativar'}</button>
        </div>
      ))}
      {lista.length === 0 && <div style={caixa}>Nenhum agente ainda — contrate o primeiro acima. 🚀</div>}
    </div>
  );
}

function AbaTrajetos() {
  const [dia, setDia] = useState(new Date(Date.now() - 3 * 3600000).toISOString().slice(0, 10));
  const [lista, setLista] = useState([]);
  useEffect(() => {
    apiGet(`pap/admin/trajetos?dia=${dia}`).then(d => setLista(Array.isArray(d) ? d : [])).catch(() => {});
  }, [dia]);
  return (
    <div>
      <div style={{ ...caixa, display: 'flex', gap: 10, alignItems: 'center' }}>
        <label style={{ fontSize: 12.5, fontWeight: 700 }}>Dia:</label>
        <input type="date" value={dia} onChange={e => setDia(e.target.value)} style={inp} />
      </div>
      {lista.map((t, i) => {
        const ini = t.pings[0], fim = t.pings[t.pings.length - 1];
        return (
          <div key={i} style={caixa}>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', fontSize: 12.5 }}>
              <b>{t.agente}</b>
              <span>🕐 {fmtDH(t.inicio)} → {t.fim ? fmtDH(t.fim) : '🟢 em andamento'}</span>
              <span style={{ fontWeight: 700 }}>📏 {(t.distancia_m / 1000).toFixed(1)} km</span>
              <span style={{ color: '#6b7280' }}>{t.pings.length} posições</span>
              {ini && <a href={`https://maps.google.com/?q=${ini.lat},${ini.lng}`} target="_blank" rel="noreferrer" style={{ fontSize: 11.5, color: '#1d4ed8' }}>📍 início</a>}
              {fim && fim !== ini && <a href={`https://maps.google.com/?q=${fim.lat},${fim.lng}`} target="_blank" rel="noreferrer" style={{ fontSize: 11.5, color: '#1d4ed8' }}>📍 última posição</a>}
            </div>
          </div>
        );
      })}
      {lista.length === 0 && <div style={caixa}>Nenhum expediente registrado em {dia.split('-').reverse().join('/')}.</div>}
    </div>
  );
}
